const $ba30e20475feac5a$export$c3ee1e672e1e24e7 = 'https://countries.dev';
const $ba30e20475feac5a$export$30dba1e0a1cb02c9 = {
    countries: 'countries',
    name: 'name',
    alpha: 'alpha'
};
const $ba30e20475feac5a$export$8c8e35f8e524b080 = [
    'name',
    'alpha2Code',
    'alpha3Code',
    'flag',
    'flags'
].join(',');
const $ba30e20475feac5a$export$c085d2ea6894d1b6 = "&#9888 We couldn't find what you're looking for. Try another query.";
const $ba30e20475feac5a$export$4048121c58168c2f = "&#9888 We had a problem trying to pull the required data. Please try again.";



const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    status: undefined,
    countries: undefined
};
const $0f1d4402dffacf5b$var$formatCountry = function(country) {
    return {
        altSpellings: country.altSpellings || [],
        area: country.area,
        borders: country.borders || [],
        capital: country.capital || '',
        cioc: country.cioc || '',
        code: country.alpha3Code || country.alpha2Code || country.numericCode,
        codes: {
            alpha2: country.alpha2Code || '',
            alpha3: country.alpha3Code || '',
            numeric: country.numericCode || ''
        },
        currencies: country.currencies || [],
        demonym: country.demonym || '',
        dialingCodes: country.callingCodes || [],
        flag: country.flags?.svg || country.flag || country.flags?.png || '',
        flagEmoji: country.flag || '',
        gini: country.gini,
        independent: country.independent,
        languages: country.languages || [],
        location: country.latlng || [],
        maps: {
            google: country.maps?.googleMaps || '',
            openStreetMaps: country.maps?.openStreetMaps || ''
        },
        name: country.name || country.nativeName || 'Unknown country',
        nativeName: country.nativeName || '',
        population: country.population,
        populationDensity: country.populationDensity,
        regionalBlocs: country.regionalBlocs || [],
        region: country.region || '',
        subregion: country.subregion || '',
        timezones: country.timezones || [],
        topLevelDomain: country.topLevelDomain || []
    };
};
const $0f1d4402dffacf5b$var$normalizeResponse = function(data) {
    if (Array.isArray(data)) return data.map($0f1d4402dffacf5b$var$formatCountry);
    return $0f1d4402dffacf5b$var$formatCountry(data);
};
const $0f1d4402dffacf5b$var$buildUrl = function(endpoint, params = {}) {
    const url = new URL(`${(0, $ba30e20475feac5a$export$c3ee1e672e1e24e7)}/${endpoint}`);
    Object.entries(params).forEach(([key, value])=>{
        url.searchParams.set(key, value);
    });
    return url;
};
const $0f1d4402dffacf5b$var$getData = async function(endpoint, params) {
    try {
        const res = await fetch($0f1d4402dffacf5b$var$buildUrl(endpoint, params));
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.status = res.status;
        if (!res.ok) return;
        const data = await res.json();
        return $0f1d4402dffacf5b$var$normalizeResponse(data);
    } catch (err) {
        console.error(err);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.status = err.message;
    }
};
const $0f1d4402dffacf5b$export$295b74b5bfa1a9f4 = async function() {
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.countries) return $0f1d4402dffacf5b$export$ca000e230c0caa3e.countries;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.countries = await $0f1d4402dffacf5b$var$getData((0, $ba30e20475feac5a$export$30dba1e0a1cb02c9).countries, {
        fields: (0, $ba30e20475feac5a$export$8c8e35f8e524b080)
    });
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.countries;
};
const $0f1d4402dffacf5b$export$d18fb0294f925f86 = async function(name) {
    return await $0f1d4402dffacf5b$var$getData(`${(0, $ba30e20475feac5a$export$30dba1e0a1cb02c9).name}/${encodeURIComponent(name)}`, {
        fields: (0, $ba30e20475feac5a$export$8c8e35f8e524b080)
    });
};
const $0f1d4402dffacf5b$export$18b02663f532815c = async function(code) {
    return await $0f1d4402dffacf5b$var$getData(`${(0, $ba30e20475feac5a$export$30dba1e0a1cb02c9).alpha}/${encodeURIComponent(code)}`, {
        full: true
    });
};


/**
 * @param {Node} parentItem
 * @description Delete all content of parent item which entered as parameter.
 */ const $bd02c871d9c5ba8e$export$42ffd38884aecdac = function(parentItem) {
    while(parentItem.hasChildNodes())parentItem.removeChild(parentItem.firstChild);
};
const $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff = function(element, action) {
    element.insertAdjacentHTML('beforeend', action);
};



class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    theme;
    spinner = document.querySelector('.loader-container');
    popup = document.querySelector('.popup');
    overlay = document.querySelector('.overlay');
    errorMessage = document.querySelector('.error-message');
    // STATUS METHODS
    renderSpinner() {
        this.spinner.style.display = 'flex';
    }
    /**
   * @param {string} errorMessage Error message which will be shown as popup.
   */ renderError(errorMessage) {
        (0, $bd02c871d9c5ba8e$export$42ffd38884aecdac)(this.errorMessage);
        this.errorMessage.insertAdjacentHTML('beforeend', errorMessage);
        this.popup.style.display = 'block';
        this.overlay.style.display = 'block';
        this.spinner.style.display = 'none';
    }
    dismissError() {
        this.popup.style.display = 'none';
        this.overlay.style.display = 'none';
    }
}


class $8b357e95b99e0408$var$CountriesView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    #listCards = document.querySelector('.list-cards');
    #showAll = document.querySelector('.show-all');
    #showAllTextKeyword = document.querySelector('.show-all-text-keyword');
    render(data) {
        (0, $bd02c871d9c5ba8e$export$42ffd38884aecdac)(this.#listCards);
        data.forEach((item)=>{
            const cardContent = `
        <hover country-code="${item.code}">
          <div class="list-card list-card--${this.theme}">
            <div class="list-card-img-frame">
              <img class="list-card-img" src="${item.flag}" alt="${item.name} flag">
            </div>
            <div class="list-card-text">
              <p>${item.name}</p>
            </div>
            <div class="list-card-save-icon"></div>
          </div>
        </hover>
      `;
            this.#listCards.insertAdjacentHTML('beforeend', cardContent);
        });
        this.spinner.style.display = 'none';
    }
    /**
   * @param {Node} input An input which comes from input variable in controller.
   */ renderShowAll(input) {
        this.#showAll.style.display = 'block';
        (0, $bd02c871d9c5ba8e$export$42ffd38884aecdac)(this.#showAllTextKeyword);
        this.#showAllTextKeyword.insertAdjacentHTML('beforeend', input.value);
        input.value = '';
    }
    /**
   * @param {Node} input An input which comes from input variable in controller.
   */ hideShowAll(input) {
        this.#showAll.style.display = 'none';
        input.value = '';
        this.renderSpinner();
    }
}
var $8b357e95b99e0408$export$2e2bcd8739ae039 = new $8b357e95b99e0408$var$CountriesView();




class $c34a89588b91ccbd$var$DetailsView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    #body = document.querySelector('body');
    #details = document.querySelector('.details');
    #detailsFlag = document.querySelector('.details-flag');
    #detailsAltSpellings = document.querySelector('.details-alt-spellings');
    #detailsArea = document.querySelector('.details-area');
    #detailsBorders = document.querySelector('.details-borders');
    #detailsCapital = document.querySelector('.details-capital');
    #detailsCioc = document.querySelector('.details-cioc');
    #detailsCodes = document.querySelector('.details-codes');
    #detailsCurrencies = document.querySelector('.details-currencies');
    #detailsDemonym = document.querySelector('.details-demonym');
    #detailsFlagEmoji = document.querySelector('.details-flag-emoji');
    #detailsGini = document.querySelector('.details-gini');
    #detailsIdd = document.querySelector('.details-idd');
    #detailsIndependent = document.querySelector('.details-independent');
    #detailsLanguages = document.querySelector('.details-languages');
    #detailsLocation = document.querySelector('.details-location');
    #detailsMapsGoogle = document.querySelector('.details-map-link--google');
    #detailsMapsOpenSt = document.querySelector('.details-map-link--openst');
    #detailsNativeName = document.querySelector('.details-native-name');
    #detailsPopulation = document.querySelector('.details-population');
    #detailsPopulationDensity = document.querySelector('.details-population-density');
    #detailsRegion = document.querySelector('.details-region');
    #detailsRegionalBlocs = document.querySelector('.details-regional-blocs');
    #detailsTimezones = document.querySelector('.details-timezones');
    #detailsTld = document.querySelector('.details-top-level-domain');
    #formatList(data, fallback = 'No data') {
        if (!data?.length) return fallback;
        return data.join(', ');
    }
    #formatBoolean(data) {
        if (data === undefined || data === null) return 'No data';
        return data ? 'Yes' : 'No';
    }
    #formatTitleCase(data) {
        if (!data) return 'No data';
        return data.toString()[0].toUpperCase() + data.toString().slice(1);
    }
    #formatCurrencies(data) {
        if (!data?.length) return 'No data';
        return data.map((cur)=>`${cur.name} (${cur.symbol || '?'})`).join(', ');
    }
    #formatLanguages(data) {
        if (!data?.length) return 'No data';
        return data.map((lang)=>lang.name || lang).join(', ');
    }
    #formatDialingCodes(data) {
        if (!data?.length) return 'No data';
        return data.map((code)=>`+${code}`).join(', ');
    }
    #formatNumber(data) {
        if (data === undefined || data === null) return 'No data';
        return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
    #formatArea(data) {
        if (data === undefined || data === null) return 'No data';
        return `${this.#formatNumber(data)} sq km`;
    }
    #formatDensity(data) {
        if (data === undefined || data === null) return 'No data';
        return `${data} people / sq km`;
    }
    #formatGini(data) {
        if (data === undefined || data === null) return 'No data';
        return data.toString();
    }
    #formatCodes(data) {
        const codes = [
            data.alpha2 && `Alpha-2: ${data.alpha2}`,
            data.alpha3 && `Alpha-3: ${data.alpha3}`,
            data.numeric && `Numeric: ${data.numeric}`
        ].filter(Boolean);
        return this.#formatList(codes);
    }
    #formatRegionalBlocs(data) {
        if (!data?.length) return 'No data';
        return data.map((bloc)=>`${bloc.name}${bloc.acronym ? ` (${bloc.acronym})` : ''}`).join(', ');
    }
    #renderImage(element, src, alt) {
        const content = src ? `<img src="${src}" alt="${alt}" class="details-img" />` : '<p class="details-text">No data</p>';
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(element, content);
    }
    #setMapLink(element, href) {
        if (href) element.setAttribute('href', href);
        else element.removeAttribute('href');
    }
    render(data) {
        this.#body.style.overflowY = 'hidden';
        this.#details.style.display = 'grid';
        this.#renderImage(this.#detailsFlag, data.flag, `${data.name} flag`);
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsAltSpellings, this.#formatList(data.altSpellings));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsArea, this.#formatArea(data.area));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsBorders, this.#formatList(data.borders, 'No borders'));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsCapital, data.capital || 'No data');
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsCioc, data.cioc || 'No data');
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsCodes, this.#formatCodes(data.codes));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsCurrencies, this.#formatCurrencies(data.currencies));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsDemonym, data.demonym || 'No data');
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsFlagEmoji, data.flagEmoji || 'No data');
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsGini, this.#formatGini(data.gini));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsIdd, this.#formatDialingCodes(data.dialingCodes));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsIndependent, this.#formatBoolean(data.independent));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsLanguages, this.#formatLanguages(data.languages));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsLocation, this.#formatList(data.location));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsNativeName, data.nativeName || 'No data');
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsPopulation, this.#formatNumber(data.population));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsPopulationDensity, this.#formatDensity(data.populationDensity));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsRegion, `${data.region || 'No data'} / ${data.subregion || '?'}`);
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsRegionalBlocs, this.#formatRegionalBlocs(data.regionalBlocs));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsTimezones, this.#formatList(data.timezones));
        (0, $bd02c871d9c5ba8e$export$21a5ca8aa77d35ff)(this.#detailsTld, this.#formatList(data.topLevelDomain));
        this.#setMapLink(this.#detailsMapsGoogle, data.maps.google);
        this.#setMapLink(this.#detailsMapsOpenSt, data.maps.openStreetMaps);
    }
    hide() {
        this.#detailsFlag.removeChild(this.#detailsFlag.lastChild);
        [
            this.#detailsAltSpellings,
            this.#detailsArea,
            this.#detailsBorders,
            this.#detailsCapital,
            this.#detailsCioc,
            this.#detailsCodes,
            this.#detailsCurrencies,
            this.#detailsDemonym,
            this.#detailsFlagEmoji,
            this.#detailsGini,
            this.#detailsIdd,
            this.#detailsIndependent,
            this.#detailsLanguages,
            this.#detailsLocation,
            this.#detailsNativeName,
            this.#detailsPopulation,
            this.#detailsPopulationDensity,
            this.#detailsRegion,
            this.#detailsRegionalBlocs,
            this.#detailsTimezones,
            this.#detailsTld
        ].forEach((domItem)=>(0, $bd02c871d9c5ba8e$export$42ffd38884aecdac)(domItem));
        this.#details.style.display = 'none';
        this.#body.style.overflowY = 'auto';
    }
}
var $c34a89588b91ccbd$export$2e2bcd8739ae039 = new $c34a89588b91ccbd$var$DetailsView();



class $16e26bb0ba3fe8ce$var$ThemesView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    #body = document.querySelector('body');
    #toolbarIcons = document.querySelector('.toolbar-icons');
    #themeIcon = document.querySelector('.night-mode svg path');
    #githubIcon = document.querySelector('.github svg');
    #hero = document.querySelector('.hero');
    #heroTitle = document.querySelector('.hero-title');
    #heroDescription = document.querySelector('.hero-description');
    #search = document.querySelector('.search');
    #searchInput = document.querySelector('.search input');
    #searchBtn = document.querySelector('.search-btn');
    #showAll = document.querySelector('.show-all');
    #showAllText = document.querySelector('.show-all-text');
    #showAllTextClick = document.querySelector('.show-all-text-click');
    #details = document.querySelector('.details');
    #detailsExitIcon = document.querySelector('.details-exit-icon');
    #detailsTitlePrimary = document.querySelector('.details-title-primary');
    #detailsTitleSecond = document.querySelectorAll('.details-title-secondary');
    #detailsText = document.querySelectorAll('.details-text');
    #detailsMapLink = document.querySelectorAll('.details-map-link');
    #listCard = document.querySelectorAll('.list-card');
    #popup = document.querySelector('.popup');
    #popupCloseBtn = document.querySelector('.btn--close-popup');
    #footer = document.querySelector('footer');
    #footerGitHubLink = document.querySelector('.footer-link--github');
    #footerApiRefLink = document.querySelector('.footer-link--apiref');
    setNightMode() {
        document.documentElement.style.setProperty('color-scheme', 'dark');
        // Redefining #listCard item
        this.#listCard = document.querySelectorAll('.list-card');
        // prettier-ignore
        this.#themeIcon.setAttribute('d', 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z');
        this.#body.style.backgroundColor = '#111111';
        this.#toolbarIcons.style.color = '#cccccc';
        this.#githubIcon.style.fill = '#cccccc';
        this.#hero.style.backgroundColor = '#333333';
        this.#heroTitle.style.color = '#eeeeee';
        this.#heroDescription.style.color = '#cccccc';
        this.#search.style.backgroundColor = '#333333';
        this.#searchInput.style.backgroundColor = '#333333';
        this.#searchInput.style.color = '#eeeeee';
        this.#searchBtn.style.backgroundColor = '#222222';
        this.#searchBtn.style.color = '#eeeeee';
        this.#showAll.style.backgroundColor = '#333333';
        this.#showAllText.style.color = '#eeeeee';
        this.#showAllTextClick.style.color = 'lightblue';
        this.#footerGitHubLink.style.color = 'lightblue';
        this.#footerApiRefLink.style.color = 'lightblue';
        this.#details.style.backgroundColor = 'rgba(18, 18, 18, 0.96)';
        this.#detailsExitIcon.style.color = '#cccccc';
        this.#detailsTitlePrimary.style.color = '#cccccc';
        this.#popup.style.backgroundColor = '#111111';
        this.#popupCloseBtn.style.color = '#eeeeee';
        this.#detailsTitleSecond.forEach((item)=>item.style.color = '#dddddd');
        this.#detailsText.forEach((item)=>item.style.color = '#eeeeee');
        this.#detailsMapLink.forEach((item)=>{
            item.style.backgroundColor = '#333333';
            item.style.color = '#eeeeee';
        });
        this.#listCard.forEach((item)=>{
            item.classList.remove('.list-card--day');
            item.classList.add('.list-card--night');
        });
        this.#listCard.forEach((item)=>{
            item.style.backgroundColor = '#333333';
            item.style.color = '#eeeeee';
        });
        this.#footer.style.color = '#cccccc';
        this.#footer.style.backgroundColor = '#333333';
        this.#searchBtn.addEventListener('mouseover', function() {
            this.style.backgroundColor = '#444444';
        });
        this.#searchBtn.addEventListener('mouseleave', function() {
            this.style.backgroundColor = '#222222';
        });
    }
    setDayMode() {
        document.documentElement.style.setProperty('color-scheme', 'light');
        // Redefining #listCard item
        this.#listCard = document.querySelectorAll('.list-card');
        // prettier-ignore
        this.#themeIcon.setAttribute('d', 'M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z');
        this.#body.style.backgroundColor = '#ffffff';
        this.#toolbarIcons.style.color = '#555555';
        this.#githubIcon.style.fill = '#555555';
        this.#hero.style.backgroundColor = '#eeeeee';
        this.#heroTitle.style.color = '#333333';
        this.#heroDescription.style.color = '#555555';
        this.#search.style.backgroundColor = '#ffffff';
        this.#searchInput.style.backgroundColor = '#ffffff';
        this.#searchInput.style.color = '#000000';
        this.#searchBtn.style.backgroundColor = '#eeeeee';
        this.#searchBtn.style.color = '#333333';
        this.#showAll.style.backgroundColor = '#ffffff';
        this.#showAllText.style.color = '#000000';
        this.#showAllTextClick.style.color = 'blue';
        this.#footerGitHubLink.style.color = 'blue';
        this.#footerApiRefLink.style.color = 'blue';
        this.#details.style.backgroundColor = 'rgba(255, 255, 255, 0.96)';
        this.#detailsExitIcon.style.color = '#333333';
        this.#detailsTitlePrimary.style.color = '#333333';
        this.#popup.style.backgroundColor = '#eeeeee';
        this.#popupCloseBtn.style.color = '#333333';
        this.#detailsTitleSecond.forEach((item)=>item.style.color = '#444444');
        this.#detailsText.forEach((item)=>item.style.color = '#555555');
        this.#detailsMapLink.forEach((item)=>{
            item.style.backgroundColor = '#ffffff';
            item.style.color = '#000000';
        });
        this.#listCard.forEach((item)=>{
            item.style.backgroundColor = '#ffffff';
            item.style.color = '#000000';
        });
        this.#footer.style.color = '#333333';
        this.#footer.style.backgroundColor = '#eeeeee';
        this.#searchBtn.addEventListener('mouseover', function() {
            this.style.backgroundColor = '#dddddd';
        });
        this.#searchBtn.addEventListener('mouseleave', function() {
            this.style.backgroundColor = '#eeeeee';
        });
    }
}
var $16e26bb0ba3fe8ce$export$2e2bcd8739ae039 = new $16e26bb0ba3fe8ce$var$ThemesView();



const $f50bd1f2915ed0f2$var$statusView = new (0, $3a07c34e115c11c9$export$2e2bcd8739ae039)();
const $f50bd1f2915ed0f2$var$toggler = document.querySelector('.night-mode');
const $f50bd1f2915ed0f2$var$search = document.querySelector('.search-btn');
const $f50bd1f2915ed0f2$var$input = document.querySelector('.search-input');
const $f50bd1f2915ed0f2$var$showAllTextClick = document.querySelector('.show-all-text-click');
const $f50bd1f2915ed0f2$var$detailsExit = document.querySelector('.details-exit');
const $f50bd1f2915ed0f2$var$btnClosePopup = document.querySelector('.btn--close-popup');
$f50bd1f2915ed0f2$var$toggler.addEventListener('click', function() {
    if ((0, $3a07c34e115c11c9$export$2e2bcd8739ae039).theme === 'day') {
        (0, $3a07c34e115c11c9$export$2e2bcd8739ae039).theme = 'night';
        localStorage.setItem('theme-v1', 'night');
        (0, $16e26bb0ba3fe8ce$export$2e2bcd8739ae039).setNightMode();
    } else {
        (0, $3a07c34e115c11c9$export$2e2bcd8739ae039).theme = 'day';
        localStorage.setItem('theme-v1', 'day');
        (0, $16e26bb0ba3fe8ce$export$2e2bcd8739ae039).setDayMode();
    }
});
$f50bd1f2915ed0f2$var$search.addEventListener('click', async function() {
    const query = $f50bd1f2915ed0f2$var$input.value.trim();
    if (query === '') return;
    // !
    $f50bd1f2915ed0f2$var$statusView.renderSpinner();
    const data = await (0, $0f1d4402dffacf5b$export$d18fb0294f925f86)(query);
    if (data) (0, $8b357e95b99e0408$export$2e2bcd8739ae039).render(data);
    else $f50bd1f2915ed0f2$var$statusView.renderError($f50bd1f2915ed0f2$var$errorHandler());
    (0, $8b357e95b99e0408$export$2e2bcd8739ae039).renderShowAll($f50bd1f2915ed0f2$var$input);
    $f50bd1f2915ed0f2$var$listCardHandler();
    (0, $3a07c34e115c11c9$export$2e2bcd8739ae039).theme === 'day' ? (0, $16e26bb0ba3fe8ce$export$2e2bcd8739ae039).setDayMode() : (0, $16e26bb0ba3fe8ce$export$2e2bcd8739ae039).setNightMode();
});
$f50bd1f2915ed0f2$var$input.addEventListener('keyup', function(e) {
    if (e.keyCode === 13) $f50bd1f2915ed0f2$var$search.click();
});
$f50bd1f2915ed0f2$var$showAllTextClick.addEventListener('click', function() {
    (0, $8b357e95b99e0408$export$2e2bcd8739ae039).hideShowAll($f50bd1f2915ed0f2$var$input);
    $f50bd1f2915ed0f2$var$init();
});
$f50bd1f2915ed0f2$var$detailsExit.addEventListener('click', ()=>(0, $c34a89588b91ccbd$export$2e2bcd8739ae039).hide());
$f50bd1f2915ed0f2$var$btnClosePopup.addEventListener('click', ()=>$f50bd1f2915ed0f2$var$statusView.dismissError());
const $f50bd1f2915ed0f2$var$errorHandler = function() {
    switch((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).status){
        case 404:
            return 0, $ba30e20475feac5a$export$c085d2ea6894d1b6;
        default:
            return 0, $ba30e20475feac5a$export$4048121c58168c2f;
    }
};
const $f50bd1f2915ed0f2$var$listCardHandler = function() {
    try {
        (0, $3a07c34e115c11c9$export$2e2bcd8739ae039).theme === 'day' ? (0, $16e26bb0ba3fe8ce$export$2e2bcd8739ae039).setDayMode() : (0, $16e26bb0ba3fe8ce$export$2e2bcd8739ae039).setNightMode();
        document.querySelectorAll('.list-card').forEach((item)=>item.addEventListener('click', async function(e) {
                const id = e.target.closest('hover').getAttribute('country-code');
                const data = await (0, $0f1d4402dffacf5b$export$18b02663f532815c)(id);
                if (data) (0, $c34a89588b91ccbd$export$2e2bcd8739ae039).render(data);
                else $f50bd1f2915ed0f2$var$statusView.renderError($f50bd1f2915ed0f2$var$errorHandler());
            }));
    } catch (err) {
        console.log(err);
    }
};
const $f50bd1f2915ed0f2$var$init = async function() {
    let data;
    if (!localStorage.getItem('theme-v1')) {
        localStorage.setItem('theme-v1', 'day');
        (0, $3a07c34e115c11c9$export$2e2bcd8739ae039).theme = localStorage.getItem('theme-v1');
    } else {
        (0, $3a07c34e115c11c9$export$2e2bcd8739ae039).theme = localStorage.getItem('theme-v1');
        (0, $3a07c34e115c11c9$export$2e2bcd8739ae039).theme === 'day' ? (0, $16e26bb0ba3fe8ce$export$2e2bcd8739ae039).setDayMode() : (0, $16e26bb0ba3fe8ce$export$2e2bcd8739ae039).setNightMode();
    }
    (0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).countries ? data = (0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).countries : data = await (0, $0f1d4402dffacf5b$export$295b74b5bfa1a9f4)();
    if (data) (0, $8b357e95b99e0408$export$2e2bcd8739ae039).render(data);
    else $f50bd1f2915ed0f2$var$statusView.renderError($f50bd1f2915ed0f2$var$errorHandler());
    $f50bd1f2915ed0f2$var$listCardHandler();
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=repo.587fca01.js.map
